import { lazy } from "react";

export const TermsOfUseGuard = lazy(() =>
  import("./TermsOfUseGuard").then(module => ({
    default: module.TermsOfUseGuard,
  })),
);

export const AdminAreaGuard = lazy(() =>
  import("./AdminAreaGuard").then(module => ({
    default: module.AdminAreaGuard,
  })),
);

export const UserSettingsAreaGuard = lazy(() =>
  import("./UserSettingsAreaGuard").then(module => ({
    default: module.UserSettingsAreaGuard,
  })),
);

export const LazyRoleCheckGuard = lazy(() =>
  import("./RoleCheckGuard").then(module => ({
    default: module.RoleCheckGuard,
  })),
);
